<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">

      <!-- Filters -->
      <md-card style="margin-bottom: 20px;">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon"><md-icon>filter_list</md-icon></div>
          <h4 class="title">Filter Orders</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout md-gutter">

            <div class="md-layout-item md-size-30 md-small-size-100">
              <md-field>
                <label>Search</label>
                <md-input v-model="filters.search" placeholder="Order #, name, email, phone..." @keyup.enter="applyFilters" />
              </md-field>
            </div>

            <div class="md-layout-item md-size-20 md-small-size-50">
              <md-field>
                <label>Order Status</label>
                <md-select v-model="filters.orderStatus" @md-selected="applyFilters">
                  <md-option value="">All</md-option>
                  <md-option value="pending">Pending</md-option>
                  <md-option value="confirmed">Confirmed</md-option>
                  <md-option value="processing">Processing</md-option>
                  <md-option value="shipped">Shipped</md-option>
                  <md-option value="delivered">Delivered</md-option>
                  <md-option value="cancelled">Cancelled</md-option>
                  <md-option value="returned">Returned</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-20 md-small-size-50">
              <md-field>
                <label>Payment Status</label>
                <md-select v-model="filters.paymentStatus" @md-selected="applyFilters">
                  <md-option value="">All</md-option>
                  <md-option value="pending">Pending</md-option>
                  <md-option value="paid">Paid</md-option>
                  <md-option value="failed">Failed</md-option>
                  <md-option value="refunded">Refunded</md-option>
                </md-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100" style="display:flex; align-items:center; padding-top:10px;">
              <md-button class="md-success" @click="applyFilters">
                <md-icon>search</md-icon> Apply
              </md-button>
              <md-button class="md-default" @click="resetFilters" style="margin-left:8px;">
                <md-icon>clear</md-icon> Reset
              </md-button>
            </div>

          </div>
        </md-card-content>
      </md-card>

      <!-- Stats -->
      <div class="md-layout md-gutter" style="margin-bottom: 20px;">
        <div class="md-layout-item md-size-20 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon total"><md-icon>receipt_long</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.total }}</span>
                <span class="stat-label">Total</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon paid"><md-icon>check_circle</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.paid }}</span>
                <span class="stat-label">Paid</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon pending"><md-icon>schedule</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.pending }}</span>
                <span class="stat-label">Pending</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon shipped"><md-icon>local_shipping</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">{{ stats.shipped }}</span>
                <span class="stat-label">Shipped</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50">
          <md-card class="stat-card">
            <md-card-content>
              <div class="stat-icon revenue"><md-icon>currency_rupee</md-icon></div>
              <div class="stat-info">
                <span class="stat-number">₹{{ stats.revenue.toLocaleString('en-IN') }}</span>
                <span class="stat-label">Revenue</span>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <!-- Table -->
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon"><md-icon>shopping_bag</md-icon></div>
          <h4 class="title">Orders</h4>
        </md-card-header>

        <md-card-content v-if="tableData.length === 0">
          <div style="text-align:center; padding:40px 0; color:#aaa;">
            <md-icon style="font-size:3rem !important;">inbox</md-icon>
            <h4>No orders found.</h4>
          </div>
        </md-card-content>

        <md-card-content v-else>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="md-container-custom paginated-table"
            table-header-color="green"
            md-fixed-header
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">

              <md-table-cell md-label="Order #" md-sort-by="orderNumber">
                <a href="javascript:void(0)"
                   @click="$router.push({ name: 'Order Detail', query: { orderId: item._id } })"
                   class="order-number-link">
                  {{ item.orderNumber }}
                </a>
              </md-table-cell>

              <md-table-cell md-label="Customer" md-sort-by="customerName">
                <div class="name-cell">
                  <div class="avatar-circle">{{ getInitials(item.customerName) }}</div>
                  <div>
                    <strong>{{ item.customerName }}</strong><br>
                    <small style="color:#888;">{{ item.customerPhone }}</small>
                  </div>
                </div>
              </md-table-cell>

              <md-table-cell md-label="Items">
                <div v-for="(it, idx) in item.items.slice(0,2)" :key="idx" class="item-row">
                  <img v-if="it.productImage" :src="it.productImage" class="item-thumb" />
                  <span>{{ it.productName }} <small style="color:#aaa;">x{{ it.quantity }}</small></span>
                </div>
                <small v-if="item.items.length > 2" style="color:#aaa;">
                  +{{ item.items.length - 2 }} more
                </small>
              </md-table-cell>

              <md-table-cell md-label="Total" md-sort-by="totalAmount">
                <strong style="font-size:1rem;">₹{{ item.totalAmount }}</strong>
                <br>
                <small v-if="item.shippingCharges" style="color:#aaa;">
                  +₹{{ item.shippingCharges }} shipping
                </small>
              </md-table-cell>

              <md-table-cell md-label="Payment" md-sort-by="paymentStatus">
                <span class="status-badge" :class="'payment-' + item.paymentStatus">
                  <md-icon style="font-size:13px !important; vertical-align:middle; margin-right:3px;">
                    {{ item.paymentStatus === 'paid' ? 'check_circle' : item.paymentStatus === 'failed' ? 'cancel' : 'schedule' }}
                  </md-icon>
                  {{ capitalize(item.paymentStatus) }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Order Status" md-sort-by="orderStatus">
                <span class="status-badge" :class="'order-' + item.orderStatus">
                  {{ capitalize(item.orderStatus) }}
                </span>
              </md-table-cell>

              <md-table-cell md-label="Date" md-sort-by="created_at">
                {{ HumanReadableDateFormat(item.created_at, true) }}
              </md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button class="md-just-icon md-info md-simple"
                  title="View Detail"
                  @click="$router.push({ name: 'Order Detail', query: { orderId: item._id } })">
                  <md-icon>visibility</md-icon>
                </md-button>
              </md-table-cell>

            </md-table-row>
          </md-table>

          <md-card-actions md-alignment="space-between">
            <div>
              <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
            </div>
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            />
          </md-card-actions>
        </md-card-content>
      </md-card>

    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import OrderService from "../../../services/OrderService";

export default {
  name: "OrderList",
  components: { Pagination },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) result = this.searchedData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) highBound = this.total;
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0 ? this.searchedData.length : this.tableData.length;
    },
    stats() {
      const all = this.tableData;
      return {
        total:    all.length,
        paid:     all.filter(o => o.paymentStatus === 'paid').length,
        pending:  all.filter(o => o.paymentStatus === 'pending').length,
        shipped:  all.filter(o => o.orderStatus === 'shipped').length,
        revenue:  all.filter(o => o.paymentStatus === 'paid').reduce((s, o) => s + (o.totalAmount || 0), 0)
      };
    }
  },
  data() {
    return {
      tableData: [],
      searchedData: [],
      currentSort: "",
      currentSortOrder: "",
      filters: { search: "", orderStatus: "", paymentStatus: "" },
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      }
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        const aVal = a[sortBy] ?? "";
        const bVal = b[sortBy] ?? "";
        if (this.currentSortOrder === "desc") return String(aVal).localeCompare(String(bVal));
        return String(bVal).localeCompare(String(aVal));
      });
    },
    getOrders() {
      const params = {};
      if (this.filters.search)        params.search        = this.filters.search;
      if (this.filters.orderStatus)   params.orderStatus   = this.filters.orderStatus;
      if (this.filters.paymentStatus) params.paymentStatus = this.filters.paymentStatus;

      OrderService.getOrders(params)
        .then(res => {
          this.tableData = res.data.data;
          this.pagination.currentPage = 1;
        })
        .catch(e => this.$toast.error(e.response?.data?.response_msg || 'Failed to load orders'));
    },
    applyFilters() { this.getOrders(); },
    resetFilters() {
      this.filters = { search: "", orderStatus: "", paymentStatus: "" };
      this.getOrders();
    },
    getInitials(name) {
      if (!name) return '?';
      return name.trim().split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
    },
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  beforeMount() { this.getOrders(); }
};
</script>

<style scoped>
.stat-card .md-card-content {
  display: flex; align-items: center; gap: 16px; padding: 20px !important;
}
.stat-icon {
  width: 52px; height: 52px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.stat-icon .md-icon { color: white !important; font-size: 1.6rem !important; }
.stat-icon.total    { background: linear-gradient(135deg, #667eea, #764ba2); }
.stat-icon.paid     { background: linear-gradient(135deg, #48bb78, #38a169); }
.stat-icon.pending  { background: linear-gradient(135deg, #ed8936, #c05621); }
.stat-icon.shipped  { background: linear-gradient(135deg, #4299e1, #2b6cb0); }
.stat-icon.revenue  { background: linear-gradient(135deg, #76acaf, #62989b); }
.stat-info { display: flex; flex-direction: column; }
.stat-number { font-size: 1.5rem; font-weight: 700; color: #2d3748; line-height: 1; }
.stat-label  { font-size: 0.78rem; color: #a0aec0; text-transform: uppercase; letter-spacing: 0.05em; margin-top: 4px; }

.name-cell { display: flex; align-items: center; gap: 10px; }
.avatar-circle {
  width: 36px; height: 36px; border-radius: 50%;
  background: linear-gradient(135deg, #76acaf, #62989b);
  color: white; display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 700; flex-shrink: 0;
}

.item-row { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; font-size: 0.85rem; }
.item-thumb { width: 32px; height: 32px; object-fit: cover; border-radius: 6px; }

.order-number-link {
  color: #4299e1; font-weight: 700; font-size: 0.9rem;
  text-decoration: none; font-family: monospace;
}
.order-number-link:hover { text-decoration: underline; }

/* Payment status badges */
.status-badge {
  display: inline-flex; align-items: center;
  padding: 4px 10px; border-radius: 20px;
  font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.04em;
}
.payment-paid              { background: rgba(72,187,120,0.15);  color: #276749; }
.payment-pending           { background: rgba(237,137,54,0.15);  color: #c05621; }
.payment-failed            { background: rgba(245,101,101,0.15); color: #c53030; }
.payment-refunded          { background: rgba(160,174,192,0.2);  color: #4a5568; }
.order-pending             { background: rgba(237,137,54,0.12);  color: #c05621; }
.order-confirmed           { background: rgba(102,126,234,0.12); color: #553c9a; }
.order-processing          { background: rgba(66,153,225,0.12);  color: #2b6cb0; }
.order-shipped             { background: rgba(56,178,172,0.12);  color: #234e52; }
.order-delivered           { background: rgba(72,187,120,0.15);  color: #276749; }
.order-cancelled           { background: rgba(245,101,101,0.12); color: #c53030; }
.order-returned            { background: rgba(160,174,192,0.2);  color: #4a5568; }
</style>